import { TOnlineBank } from './OpenBanking.types';
import { TGetContext, TOfferDataRequirement } from '../../../types';

type TRecommendedResolutionMethodItem = {
  external_id: string;
  online_account__bank: string;
  online_account__status_code: string;
  account_number_masked: string;
};

export type TLinkedBankAccount = Pick<
  TOnlineBank,
  'bank_name' | 'logo_url' | 'account_number_masked'
>;

export const getLinkedBankAccountDetails = (
  resolutionMethods: TOfferDataRequirement['actions'][number]['resolution_methods'],
  context: TGetContext['data'],
): TLinkedBankAccount[] | undefined => {
  const openBankingResolutionMethod = resolutionMethods.find(
    (resolutionMethod) =>
      resolutionMethod.type === 'link_bank_account_via_open_banking',
  );

  if (
    !openBankingResolutionMethod ||
    openBankingResolutionMethod.items.length < 1
  )
    return;

  const trueLayerBanks: TOnlineBank[] | undefined =
    context.open_banking.truelayer_banks;

  if (!trueLayerBanks) return;

  // @ts-expect-error typed as any[] in schema so not picked up by LAPI
  const linkedAccounts: TRecommendedResolutionMethodItem[] =
    openBankingResolutionMethod.items;

  const linkedBankAccountDetails: TLinkedBankAccount[] = [];

  for (const linkedAccount of linkedAccounts) {
    const matchedBank = trueLayerBanks.find(
      (bank) => bank.bank_id === linkedAccount.online_account__bank,
    );

    if (matchedBank) {
      linkedBankAccountDetails.push({
        bank_name: matchedBank.bank_name,
        logo_url: matchedBank.logo_url,
        account_number_masked: linkedAccount.account_number_masked,
      });
    }
  }

  return linkedBankAccountDetails.length > 0
    ? linkedBankAccountDetails
    : undefined;
};

export const inferProvider = (bankId: string): 'truelayer' | 'finapi' => {
  if (bankId.startsWith('xs2a-') || bankId.startsWith('ob-')) {
    return 'truelayer';
  }
  // FinAPI bank IDs are always numeric
  if (/^\d+$/.test(bankId)) {
    return 'finapi';
  }
  throw new Error(`Unknown provider for bank_id: ${bankId}`);
};
